import { SxProps, Theme } from '@mui/material';

export const deliveryLocatorHeaderInfoSX = (theme: Theme, isSelected: boolean): SxProps<Theme> => ({
	display: 'flex',
	alignItems: 'center',
	cursor: 'pointer',
	padding: '10px',
	gap: '5px',
	flexDirection: 'row',
	borderRadius: '3px',
	width: 'auto',
	...(isSelected && { backgroundColor: 'grey.50' }),
	'&:hover': {
		backgroundColor: 'grey.50',
	},
	[theme.breakpoints.down('md')]: {
		gap: '2px',
		flexDirection: 'column',
	},
	margin: 'auto',
});

export const deliveryLocatorHeaderContainerSX: SxProps = {
	display: 'flex',
	alignItems: 'center',
	gap: '5px',
	flexDirection: 'row',
};

export const deliveryLocatorHeaderInfoTextSX: SxProps = {
	color: 'grey.200',
};

export const deliveryLocatorHeaderInfoZipCodeSX: SxProps = {
	color: 'secondary.main',
};
